import React from 'react';

const STEPS = ['Generate', 'Decide', 'Act', 'Grade', 'Train'];
const C = 200;
const R = 138;

// Five nodes on a ring. The white paper uses the research loop; the homepage uses the process.
export default function LoopRing({ labelled = false, className = '', steps = STEPS }) {
  const nodes = steps.map((name, i) => {
    const angle = ((-90 + i * 72) * Math.PI) / 180;
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);
    return {
      name,
      x: C + R * cos,
      y: C + R * sin,
      lx: C + (R + 26) * cos,
      ly: C + (R + 26) * sin + (sin < -0.5 ? -4 : sin > 0.5 ? 12 : 4),
      anchor: cos > 0.3 ? 'start' : cos < -0.3 ? 'end' : 'middle',
    };
  });

  return (
    <svg
      className={`loop-ring ${className}`.trim()}
      viewBox="-40 -20 480 440"
      role="img"
      aria-label={steps.join(', ')}
    >
      <circle className="loop-ring__track" cx={C} cy={C} r={R} />
      <circle className="loop-ring__inner" cx={C} cy={C} r={R * 0.66} />
      <circle className="loop-ring__flow" cx={C} cy={C} r={R} pathLength="100" transform={`rotate(-90 ${C} ${C})`} />
      {nodes.map((node, i) => (
        <g key={node.name} className="loop-ring__node" style={{ '--i': i }}>
          <circle className="loop-ring__halo" cx={node.x} cy={node.y} r={i === 0 ? 15 : 12} />
          <circle className="loop-ring__dot" cx={node.x} cy={node.y} r={i === 0 ? 6.5 : 5} />
          {labelled ? (
            <text className="loop-ring__label" x={node.lx} y={node.ly} textAnchor={node.anchor}>
              {node.name}
            </text>
          ) : null}
        </g>
      ))}
    </svg>
  );
}
